import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/pl';
import 'dayjs/locale/ro';
import 'dayjs/locale/uk';
import daysEN from '@lib/locales/en/days.json';
import daysES from '@lib/locales/es/days.json';
import daysFR from '@lib/locales/fr/days.json';
import daysPL from '@lib/locales/pl/days.json';
import daysRO from '@lib/locales/ro/days.json';
import daysUK from '@lib/locales/uk/days.json';

dayjs.extend(updateLocale);

// dayjs locale names differ from i18n language codes only for English, where
// the app uses the British variant (Monday week start, DD/MM order)
const DAYJS_LOCALE_BY_LANGUAGE: Record<string, string> = {
  en: 'en-gb',
  es: 'es',
  fr: 'fr',
  pl: 'pl',
  ro: 'ro',
  uk: 'uk',
};

const DAYS_TRANSLATIONS_BY_LANGUAGE: Record<string, Record<string, string>> = {
  en: daysEN,
  es: daysES,
  fr: daysFR,
  pl: daysPL,
  ro: daysRO,
  uk: daysUK,
};

const DEFAULT_DAYJS_LOCALE = 'en-gb';

// Align dayjs short month names (`MMM`, antd month panel) with the `month-N`
// translations used elsewhere in the UI (e.g. timeline headers), so the same
// month is never spelled two ways on one screen (`sept.` vs `Sep`)
Object.entries(DAYS_TRANSLATIONS_BY_LANGUAGE).forEach(([language, days]) => {
  dayjs.updateLocale(DAYJS_LOCALE_BY_LANGUAGE[language], {
    monthsShort: Array.from({ length: 12 }, (_, i) => days[`month-${i + 1}`]),
  });
});

export default function getDayjsLocale(language?: string): string {
  const baseLanguage = language?.toLowerCase().split('-')[0] ?? '';
  return DAYJS_LOCALE_BY_LANGUAGE[baseLanguage] ?? DEFAULT_DAYJS_LOCALE;
}
